/**
 * Web Storage Adapter - Browser localStorage implementation
 * @module @one-payments/adapters-web
 */

import type { StorageAdapter } from '@one-payments/core';

/**
 * Web Storage Adapter using localStorage
 */
export class WebStorageAdapter implements StorageAdapter {
  private readonly prefix: string;

  constructor(prefix = 'one-payments:') {
    this.prefix = prefix;
  }

  public async get(key: string): Promise<string | null> {
    return localStorage.getItem(this.prefix + key);
  }

  public async set(key: string, value: string): Promise<void> {
    localStorage.setItem(this.prefix + key, value);
  }

  public async remove(key: string): Promise<void> {
    localStorage.removeItem(this.prefix + key);
  }

  public async clear(): Promise<void> {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (key.startsWith(this.prefix)) {
        localStorage.removeItem(key);
      }
    });
  }
}
